import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import {
    AclResource,
    APIAclResourceDelete,
    APIAclResourceGet,
    APIAclResourceGetList,
    APIAclResourcePost,
    APIAclResourcePostParams,
    APIAclResourcePostResponse,
    APIAclResourcePut,
    APIAclResourcePutParams,
    APIAclResourcePutResponse
} from './AclResources.api';

export const fetchAclResources = createAsyncThunk('aclResources/fetchAclResources', async (item: { tenantId: string, signal?: AbortSignal }) => {
    const response = await APIAclResourceGetList(item);
    return response.data;
});

export const fetchAclResource = createAsyncThunk('aclResources/fetchAclResource', async (item: { tenantId: string, id: string, signal?: AbortSignal }) => {
    const response = await APIAclResourceGet(item);
    return response.data;
});

export type PostAclResourceThunkResponse = {
    item: APIAclResourcePostParams,
    response: APIAclResourcePostResponse,
    rows: AclResource[]
}

export const postAclResource = createAsyncThunk('aclResources/postAclResource', async (item: { tenantId: string, name: string, displayName: string | undefined  }) => {
    const response = await APIAclResourcePost(item);
    const rows = await handleListFetch(APIAclResourceGetList( { tenantId: item.tenantId }));
    return {
        item,
        response,
        rows
    };
});

export const deleteAclResource = createAsyncThunk('aclResources/deleteAclResource', async (item: {tenantId: string, id: string}) => {
    const response = await APIAclResourceDelete(item);
    const rows = await handleListFetch(APIAclResourceGetList({ tenantId: item.tenantId }));
    return {
        item,
        response,
        rows
    };
});

export type PutAclResourceThunkResponse = {
    item: APIAclResourcePutParams,
    response: APIAclResourcePutResponse,
    rows: AclResource[]
}

export const putAclResource = createAsyncThunk('aclResources/putAclResource', async (item: APIAclResourcePutParams)=> {
    const response = await APIAclResourcePut(item);
    const rows = await handleListFetch(APIAclResourceGetList( { tenantId: item.tenantId }));
    return {
        item,
        response,
        rows
    };
});
